var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _path5, _circle, _path6, _path7, _circle2, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "graphic_upload_document",
    "data-name": "graphic / upload document",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.384,
    height: 30.692,
    viewBox: "0 0 25.384 30.692",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M18.3,0H.621A.622.622,0,0,0,0,.622v23.91a.622.622,0,0,0,.621.622H18.3a.622.622,0,0,0,.621-.622V.622A.622.622,0,0,0,18.3,0Z",
    fill: "#d3dbeb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M.429,0A.435.435,0,0,0,0,.439V23.1a.435.435,0,0,0,.429.439h16.68a.435.435,0,0,0,.429-.439V.439A.435.435,0,0,0,17.109,0Z",
    transform: "translate(0.692 0.692)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M.287,0A.3.3,0,0,0,0,.316V3.376a.3.3,0,0,0,.287.316H15.174a.3.3,0,0,0,.287-.316V.316A.3.3,0,0,0,15.174,0Z",
    transform: "translate(1.846 1.846)",
    fill: "#e9edf5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M.287,0A.294.294,0,0,0,0,.3V7.085a.294.294,0,0,0,.287.3H15.174a.294.294,0,0,0,.287-.3V.3a.294.294,0,0,0-.287-.3Z",
    transform: "translate(1.846 7.154)",
    fill: "#e9edf5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 11.769,
    height: 0.692,
    transform: "translate(3.692 2.538)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    width: 11.769,
    height: 0.231,
    transform: "translate(3.692 3.877)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    "data-name": "Rectangle",
    width: 11.769,
    height: 0.231,
    transform: "translate(3.692 4.615)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M7.809,5.769h5.4a.174.174,0,0,0,.161-.11.181.181,0,0,0-.038-.194L9.877,1.928a.171.171,0,0,0-.246,0l-.86.88a.359.359,0,0,1-.516,0L5.563.052a.171.171,0,0,0-.246,0L.051,5.441a.181.181,0,0,0-.038.194.174.174,0,0,0,.161.11H7.816Z",
    transform: "translate(2.769 8.769)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.692,
    cy: 0.692,
    r: 0.692,
    transform: "translate(3.461 8.077)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M.287,0A.294.294,0,0,0,0,.3V7.085a.294.294,0,0,0,.287.3H15.174a.294.294,0,0,0,.287-.3V.3a.294.294,0,0,0-.287-.3Z",
    transform: "translate(1.846 15.923)",
    fill: "#e9edf5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    "data-name": "Path",
    d: "M7.809,5.769h5.4a.174.174,0,0,0,.161-.11.181.181,0,0,0-.038-.194L9.877,1.928a.171.171,0,0,0-.246,0l-.86.88a.359.359,0,0,1-.516,0L5.563.052a.171.171,0,0,0-.246,0L.051,5.441a.181.181,0,0,0-.038.194.174.174,0,0,0,.161.11H7.816Z",
    transform: "translate(2.769 17.538)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    "data-name": "Oval",
    cx: 0.692,
    cy: 0.692,
    r: 0.692,
    transform: "translate(3.461 16.846)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    "data-name": "Path",
    d: "M.439,0A.438.438,0,0,0,0,.437V24.716a.438.438,0,0,0,.439.437H18.484a.438.438,0,0,0,.439-.437V.437A.438.438,0,0,0,18.484,0Z",
    transform: "translate(6.461 5.538)",
    fill: "#d3dbeb"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path-9",
    "data-name": "Path",
    d: "M.429,0A.437.437,0,0,0,0,.443V23.326a.437.437,0,0,0,.429.443h16.68a.437.437,0,0,0,.429-.443V.443A.437.437,0,0,0,17.109,0Z",
    transform: "translate(7.154 6.231)",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path-10",
    "data-name": "Path",
    d: "M.193,0A.185.185,0,0,0,0,.175v.8a.185.185,0,0,0,.193.175H11.576a.185.185,0,0,0,.193-.175v-.8A.185.185,0,0,0,11.576,0Z",
    transform: "translate(9.692 9.461)",
    fill: "#0676ed"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path-11",
    "data-name": "Path",
    d: "M.048,0A.049.049,0,0,0,0,.05V.411a.049.049,0,0,0,.048.05H11.491a.049.049,0,0,0,.048-.05V.05A.049.049,0,0,0,11.491,0Z",
    transform: "translate(9.923 12.461)",
    fill: "#eaf0fb"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path-12",
    "data-name": "Path",
    d: "M.048,0A.049.049,0,0,0,0,.05V.411a.049.049,0,0,0,.048.05H11.491a.049.049,0,0,0,.048-.05V.05A.049.049,0,0,0,11.491,0Z",
    transform: "translate(9.923 13.615)",
    fill: "#eaf0fb"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path-13",
    "data-name": "Path",
    d: "M.048,0A.049.049,0,0,0,0,.05V.411a.049.049,0,0,0,.048.05H11.491a.049.049,0,0,0,.048-.05V.05A.049.049,0,0,0,11.491,0Z",
    transform: "translate(9.923 14.769)",
    fill: "#eaf0fb"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path-14",
    "data-name": "Path",
    d: "M.048,0A.049.049,0,0,0,0,.05V.411a.049.049,0,0,0,.048.05H11.491a.049.049,0,0,0,.048-.05V.05A.049.049,0,0,0,11.491,0Z",
    transform: "translate(9.923 16.846)",
    fill: "#eaf0fb"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path-15",
    "data-name": "Path",
    d: "M.048,0A.049.049,0,0,0,0,.05V.411a.049.049,0,0,0,.048.05H11.491a.049.049,0,0,0,.048-.05V.05A.049.049,0,0,0,11.491,0Z",
    transform: "translate(9.923 18)",
    fill: "#eaf0fb"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path-16",
    "data-name": "Path",
    d: "M.048,0A.049.049,0,0,0,0,.05V.411a.049.049,0,0,0,.048.05H11.491a.049.049,0,0,0,.048-.05V.05A.049.049,0,0,0,11.491,0Z",
    transform: "translate(9.923 19.153)",
    fill: "#eaf0fb"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path-17",
    "data-name": "Path",
    d: "M.048,0A.049.049,0,0,0,0,.05V.411a.049.049,0,0,0,.048.05H11.491a.049.049,0,0,0,.048-.05V.05A.049.049,0,0,0,11.491,0Z",
    transform: "translate(9.923 20.307)",
    fill: "#eaf0fb"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path-18",
    "data-name": "Path",
    d: "M.048,0A.049.049,0,0,0,0,.05V.411a.049.049,0,0,0,.048.05H11.491a.049.049,0,0,0,.048-.05V.05A.049.049,0,0,0,11.491,0Z",
    transform: "translate(9.923 21.461)",
    fill: "#eaf0fb"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path-19",
    "data-name": "Path",
    d: "M.048,0A.049.049,0,0,0,0,.05V.411a.049.049,0,0,0,.048.05H11.491a.049.049,0,0,0,.048-.05V.05A.049.049,0,0,0,11.491,0Z",
    transform: "translate(9.923 22.615)",
    fill: "#eaf0fb"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path-20",
    "data-name": "Path",
    d: "M.048,0A.049.049,0,0,0,0,.05V.411a.049.049,0,0,0,.048.05H11.491a.049.049,0,0,0,.048-.05V.05A.049.049,0,0,0,11.491,0Z",
    transform: "translate(9.923 23.769)",
    fill: "#eaf0fb"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path-21",
    "data-name": "Path",
    d: "M.048,0A.049.049,0,0,0,0,.05V.411a.049.049,0,0,0,.048.05H11.491a.049.049,0,0,0,.048-.05V.05A.049.049,0,0,0,11.491,0Z",
    transform: "translate(9.923 24.923)",
    fill: "#eaf0fb"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path-22",
    "data-name": "Path",
    d: "M.048,0A.049.049,0,0,0,0,.05V.411a.049.049,0,0,0,.048.05H11.491a.049.049,0,0,0,.048-.05V.05A.049.049,0,0,0,11.491,0Z",
    transform: "translate(9.923 26.076)",
    fill: "#eaf0fb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUpload);
export default __webpack_public_path__ + "static/media/image_upload.4cc2e6c154799e4dce9fabc0ad1078ee.svg";
export { ForwardRef as ReactComponent };